import FingoMuiRadio from '../../fingo/components/MuiRadio';
import DEFAULT_RADIO_CLASS_NAME, { RADIO_BORDER_HOVER_COLOR_VAR, RADIO_CHECKED_BG_COLOR_VAR, RADIO_CHECKED_MAIN_COLOR_VAR } from '../../constants/radio';

const defaultRadioStyles = ({ theme }) => ({
  [RADIO_BORDER_HOVER_COLOR_VAR]: theme.palette.secondary.main,
  [RADIO_CHECKED_BG_COLOR_VAR]: theme.palette.secondary.A100,
  [RADIO_CHECKED_MAIN_COLOR_VAR]: theme.palette.secondary.main,
});

const MuiRadio = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiRadio.styleOverrides.root({ theme }),
      [`&.${DEFAULT_RADIO_CLASS_NAME}`]: defaultRadioStyles({ theme }),
    }),
  },
};

export default MuiRadio;
